import { useEffect } from "react";
import URLService from "../service/urlService";

function RedirectToArrivalCustoms() {
  useEffect(() => {
    window.location.href = URLService.generateRedirectUrl(
      window._env_.REACT_APP_ARRIVAL_CUSTOMS_URL
    );
  }, []);

  return null;
}

export default RedirectToArrivalCustoms;
